/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Forecast arrival and departure of one child, with the source of each time.
 */
export type shifts_SlotChildPresenceDTO = {
    arrival: string;
    /**
     * ArrivalDriftMinutes is expected - history in minutes when an expected arrival differs
     * from the check-in history by more than 30 minutes; else null (#1583).
     */
    arrival_drift_minutes?: number | null;
    arrival_samples: number;
    arrival_source: shifts_SlotChildPresenceDTO.arrival_source;
    booked_from?: string;
    booked_to?: string;
    child_id: string;
    departure: string;
    /**
     * DepartureDriftMinutes is the same for the departure.
     */
    departure_drift_minutes?: number | null;
    departure_samples: number;
    departure_source: shifts_SlotChildPresenceDTO.departure_source;
    display_name: string;
    outside_booking: boolean;
};
export namespace shifts_SlotChildPresenceDTO {
    export enum arrival_source {
        EXPECTED = 'EXPECTED',
        HISTORY = 'HISTORY',
        BOOKING = 'BOOKING',
    }
    export enum departure_source {
        EXPECTED = 'EXPECTED',
        HISTORY = 'HISTORY',
        BOOKING = 'BOOKING',
    }
}

